<template>
    <div v-html="icon"></div>
</template>

<script>
export default {
  props: ['icon']
}
</script>
